<template>
    <CCard>
        <CCardBody>
            <CContainer class="section" fluid>
                <CRow class="border-bottom">
                    <CCol md="10">
                        <h2 class="section__title my-4">
                            {{ $t("sub_tags_config") }}
                        </h2>
                    </CCol>
                </CRow>
                <CRow alignHorizontal="center">
                    <CCol md="12">
                        <CDataTable
                            :addTableClasses="['table--sm']"
                            :fields="
                                traslateArrayObjects({
                                    array: tables.subTags.fields,
                                    fields: ['label'],
                                })
                            "
                            :itemsPerPageSelect="{
                                values: [5, 10, 20],
                            }"
                            :columnFilterValue.sync="
                                tables.subTags.columnFilterValue
                            "
                            @update:column-filter-value="updateData()"
                            @pagination-change="itemPerPage"
                            :items-per-page="tables.subTags.rows"
                            v-bind="tables.subTags"
                        >
                            <template #options>
                                <td class="py-2 text-center">
                                    <CButton
                                        color="danger"
                                        variant="outline"
                                        class="ml-1"
                                        square
                                        size="sm"
                                    >
                                        <CIcon
                                            class="icon"
                                            :content="$options.icons.cilTrash"
                                        />
                                    </CButton>
                                </td>
                            </template>
                            <template #over-table>
                                <CButton
                                    color="success"
                                    class="button m-2 shadow"
                                    v-if="tables.subTags.items.length > 0"
                                    @click="
                                        openModal({
                                            modalName: 'addSubTag',
                                            data: {
                                                tagUuid,
                                            },
                                        })
                                    "
                                >
                                    <span class="button__icon">
                                        <CIcon
                                            :content="$options.icons.cilPlus"
                                        />
                                    </span>
                                    <span class="button__text">
                                        {{ $t("add_sub_tag") }}
                                    </span>
                                </CButton>
                            </template>
                            <template #no-items-view>
                                <div class="block-no-items section">
                                    <h2 class="section__title text-no-items">
                                        {{ $t("add_sub_tag") }}
                                    </h2>
                                    <CButton
                                        color="success"
                                        class="button m-2 shadow"
                                        @click="
                                            openModal({
                                                modalName: 'addSubTag',
                                                data: {
                                                    tagUuid,
                                                },
                                            })
                                        "
                                    >
                                        <span class="button__icon">
                                            <CIcon
                                                :content="
                                                    $options.icons.cilPlus
                                                "
                                            />
                                        </span>
                                        <span class="button__text">
                                            {{ $t("add_sub_tag") }}
                                        </span>
                                    </CButton>
                                </div>
                            </template>
                        </CDataTable>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
        <AddSubTagModal
            v-bind="modals.addSubTag"
            :show.sync="modals.addSubTag.show"
            v-on:submit="updateData"
        />
    </CCard>
</template>

<script>
/** Components */
import ButtonBack from "£lement/ButtonBack";
import ButtonLoading from "~/components/ButtonLoading.vue";
import AddSubTagModal from "~/pages/Admin/Headers/Components/AddSubTagModal.vue";
/** Mixins */
import { validationMixin } from "vuelidate";
import tableMixin from "~/mixins/table";
import modalMixin from "~/mixins/modal";
import traslateMixin from "~/mixins/traslate.js";

/** Others */
import { required } from "vuelidate/lib/validators";
import {
    cilPencil,
    cilCaretBottom,
    cilCaretTop,
    cilSave,
    cilPlus,
    cilTrash,
} from "@coreui/icons";

export default {
    name: "SubTagTab",
    mixins: [validationMixin, traslateMixin, tableMixin, modalMixin],
    icons: {
        cilPencil,
        cilCaretBottom,
        cilCaretTop,
        cilSave,
        cilPlus,
        cilTrash,
    },

    components: {
        ButtonBack,
        ButtonLoading,
        AddSubTagModal,
    },

    props: {
        tagUuid: {
            required,
        },
        loading: Boolean,
    },

    data() {
        return {
            tables: {
                subTags: {
                    items: [],
                    fields: [
                        {
                            label: "id",
                            key: "id",
                        },
                        {
                            label: "name",
                            key: "name",
                        },
                        {
                            label: "code",
                            key: "code",
                        },
                        {
                            label: "options",
                            key: "options",
                        },
                    ],
                    order: "desc",
                    rows: 10,
                    page: 1,
                    total_pages: 0,
                    loading: true,
                    pagination: true,
                    sorter: true,
                    responsive: true,
                    columnFilter: {
                        external: true,
                        lazy: true,
                    },
                    columnFilterValue: {},
                    itemsPerPageSelect: true,
                },
            },
            modals: {
                addSubTag: {
                    show: false,
                    color: "primary",
                    title: "add_sub_tag",
                    data: {
                        tagUuid: null,
                    },
                },
            },
        };
    },
    watch: {},
    validations: {},
    methods: {
        itemPerPage(newValue) {
            this.tables.subTags.rows = newValue;
            this.updatePagination(this.tables.subTags.page);
        },
        updatePagination(newValue) {
            this.tables.subTags.page = newValue;
            this.updateData();
        },
        async updateData() {
            await this.updateTable({
                tableName: "subTags",
                url: `/tags/${this.tagUuid}/sub-tags`,
                fetch: {
                    baseURL: process.env.VUE_APP_API_CORE,
                },
                adapterFilters: (filters)=>{
                    delete filters.where.created_at
                    return filters;
                }
            });
            this.tables.subTags.loading = false;
        },
    },
    async mounted() {
        await this.updateData();
    },
};
</script>

<style>
</style>